<template>
  <div class="bg-white w-full">
    <el-card class="elshadow rounded-10px mb-4">
      <div class="flex items-center">
        <img
          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained/builder/dev.png"
          alt="image"
          class="avatar-imgw"
        />
        <div class="pl-4 w-full">
          <h2 class="fsize16 text-black font-semibold">Developer 3</h2>
        </div>
      </div>

      <div class="mt-8">
        <h4 class="font-semibold fsize16 text-4f4f4f mb-2">Overview</h4>
        <p class="text-8f8f8f">
          A UI Developer translates all the wireframes designed in the Design
          phase into functional UI elements.
        </p>
      </div>
    </el-card>
    <div class="flex w-full gap-4">
      <div class="w-full">
        <!-- <div>
          <label class="mb-0 font-medium">Search </label>
          <div class="relative mt-2">
            <el-input
              placeholder="Please input"
              v-model="input"
              class="rounded-none"
            ></el-input>
            <div class="absolute top-0 right-0 mt-2 mr-2">
              <feather-icon icon="SearchIcon" class="" @click="getAssignTask" />
            </div>
          </div>
        </div> -->
        <div class="w-full">
          <div class="grid grid-cols-3 gap-2">
            <div>
              <label class="mb-0 font-medium">Search by Date</label>
              <el-date-picker
                v-model="startDate"
                type="date"
                placeholder="Pick a day"
                class="mt-2 w-full"
                format="dd-MM-yyyy"
              >
              </el-date-picker>
            </div>
            <div class="w-full">
              <label class="mb-0 font-medium">to</label>
              <el-date-picker
                v-model="endDate"
                type="date"
                placeholder="Pick a day"
                class="mt-2 w-full"
                format="dd-MM-yyyy"
              >
              </el-date-picker>
            </div>
            <div class="w-full">
              <label class="mb-0 font-medium">Search by Status</label>
              <div class="mt-2">
                <el-select
                  v-model="value2"
                  placeholder="Select"
                  @change="getAssignTask"
                  class="w-full"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- <div class="absolute top-0 right-0 mt-2 mr-2">
              <feather-icon icon="SearchIcon" class="" @click="getAssignTask" />
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- :class="{
          'bg-light-green': row.assigneeStatus === 'Completed',
          'bg-fas': row.assigneeStatus === 'Not Started',
          'bg-light-orange': row.assigneeStatus === 'WIP',
        }" -->
    <div class="grid grid-cols-3 gap-6 mt-12 pb-10">
      <div class="p-5" v-for="row in alldata.data" :key="row._id">
        <div class="flex items-center gap-2">
          <p
            class="text-success text-sm font-semibold"
            v-if="row.typeOfTask == 'User Story'"
          >
            {{ row.typeOfTask }}
          </p>
          <p
            class="text-success text-sm font-semibold"
            v-else-if="row.taskId == 'Task'"
          >
            Task
          </p>
          <p class="text-success text-sm font-semibold" v-else></p>
          <p
            class="text-8f8f8f text-sm font-semibold"
            v-if="
              row.taskId
                ? row.taskId.manHrs
                  ? row.taskId.manHrs
                  : false
                : false
            "
          >
            {{ Number(row.taskId.manHrs).toFixed(2) }} Mhrs
          </p>
          <p class="text-8f8f8f text-sm font-semibold" v-else>0 Mhrs</p>
        </div>
        <div>
          <h6 class="text-black font-semibold text-lg mt-5">{{ row.name }}</h6>
          <p class="text-8f8f8f text-sm font-medium mt-1">
            {{ row.description }}
          </p>
        </div>
        <div class="mt-6">
          <div class=" ">
            <p
              class="bg-light-orange fsize10 w-24 h-8 rounded-full flex justify-center items-center font-semibold"
              v-if="row.assigneeStatus == 'WIP'"
            >
              Pending
            </p>
            <p
              class="text-fas flex justify-center fsize10 w-24 h-8 rounded-full items-center bg-glass fsize10 font-semibold"
              v-else
            >
              {{ row.assigneeStatus }}
            </p>
            <p class="text-8f8f8f text-sm font-medium mt-1">
              {{ getDate(row.createdAt) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full flex justify-end mt-6">
      <el-pagination
        @current-change="
          (value) => {
            currentPage = value;
            getAssignTask();
          }
        "
        background
        layout="prev,pager,next"
        :total="alldata.count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const debounce = function debounce(func, wait = 800) {
  let debounceTimer;
  return function (...args) {
    if (debounceTimer) clearTimeout(debounceTimer);
    const context = this;
    debounceTimer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};
export default {
  data() {
    return {
      perPage: 9,
      currentPage: 1,
      input: "",
      value: "",
      value2: "",
      startDate: "",
      endDate: "",
      options: [
        { label: "Not Started", value: "Not Started" },
        { label: "Pending", value: "Pending" },
        { label: "All", value: "All" },
      ],
      alldata: {},
    };
  },
  computed: {
    ...mapState("admin", ["login"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("design", ["selectedSprint"]),
  },
  methods: {
    getDate(date) {
      return moment(date).format("MMMM Do YYYY");
    },
    async getAssignTask() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        assignToMe: this.selectedSprint.DEV[2]._id,
        searchQuery: this.input,
        assigneeStatuses: ["WIP", "Not Started"],
        paginated: true,
        limit: this.perPage,
      };
      if (this.currentPage == 1) {
        Object.assign(payload, { offset: this.perPage - 9 });
      } else {
        Object.assign(payload, {
          offset: this.perPage * (this.currentPage - 1),
        });
      }
      if (this.value2 == "Not Started") {
        Object.assign(payload, { status: "Not Started" });
      } else if (this.value2 == "Pending") {
        Object.assign(payload, { status: "WIP" });
      }
      if (this.startDate && this.endDate) {
        if (this.startDate) {
          Object.assign(payload, { dateRange: true });
          Object.assign(payload, { startDate: this.startDate });
        }
        if (this.endDate) {
          Object.assign(payload, { dateRange: true });
          Object.assign(payload, { endDate: this.endDate });
        }
      }

      let data = await this.$store.dispatch("builder/paginatedTasks", payload);
      console.log(data);

      this.alldata = data.data;
    },
  },
  async mounted() {
    this.getAssignTask();
  },
  watch: {
    startDate: debounce(async function (newValue) {
      if (newValue !== "" && this.endDate) {
        this.getAssignTask();
      }
    }),
    endDate: debounce(async function (newValue) {
      if (this.startDate && newValue !== "") {
        this.getAssignTask();
      }
    }),
  },
};
</script>

<style></style>
